var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fixed-shell"},[_c('div',{staticClass:"fixed-container"},[_c('div',{staticClass:"fixed-item",style:(_vm.itemStyle)},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }